export default __webpack_public_path__ + "ef59f1c1b2a1bcc6489ded37c0ab398a.png";